var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showPaymentStatus)?_c(_vm.tag,_vm._b({tag:"component",staticClass:"chip-smaller",class:{
    'text-center': _vm.center,
    'px-2': _vm.center
  }},'component',_vm.$attrs,false),[_c('AppChip',{attrs:{"color":_vm.chipColor,"text-color":"white--text"}},[_vm._v("\n    "+_vm._s(_vm.chipText)+"\n  ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }